var React = require('react');

function ArrowVs (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.586 16.4142C14.3671 17.1953 15.6334 17.1953 16.4145 16.4142L29.1424 3.68629C29.9234 2.90524 29.9234 1.63891 29.1424 0.857864C28.3613 0.076815 27.095 0.0768151 26.314 0.857864L15.0002 12.1716L3.68654 0.857865C2.90549 0.0768161 1.63916 0.0768162 0.858108 0.857865C0.0770593 1.63891 0.0770593 2.90524 0.858108 3.68629L13.586 16.4142ZM13.0002 12L13.0002 15L17.0002 15L17.0002 12L13.0002 12Z","fill":"#5DBDE6"}));
}

ArrowVs.defaultProps = {"width":"30","height":"17","viewBox":"0 0 30 17","fill":"none"};

module.exports = ArrowVs;

ArrowVs.default = ArrowVs;
